import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { ClipboardList } from "lucide-react";
import { TRATTA_OPTIONS } from "../../lib/options";
import { SEZ, Field, Sel, withCurrent } from "./fields";

export const OperativeSection = ({ operative, setOperative, options, richiedenteOptions }) => {
  const upd = (k) => (v) => setOperative({ ...operative, [k]: v });
  return (
    <SEZ icon={ClipboardList} title="Info Operative">
      <Field label="Data e Ora Evento" type="datetime-local" value={operative.data_ora_evento} onChange={upd("data_ora_evento")} testid="op-dataora" />
      <Field label="Orario Visita / Fine" value={operative.orario_visita} onChange={upd("orario_visita")} testid="op-orario" />
      <Field label="Referente Operativo Nexus" value={operative.referente} onChange={upd("referente")} testid="op-referente" />
      <Sel label="Richiedente" value={operative.provenienza} onChange={upd("provenienza")} options={richiedenteOptions} testid="op-provenienza" />
      <Sel label="Attività" value={operative.attivita} onChange={upd("attivita")} options={withCurrent(options.attivita, operative.attivita)} testid="op-attivita" />
      <Sel label="Tipologia Mezzo" value={operative.tipologia_mezzo} onChange={upd("tipologia_mezzo")} options={withCurrent(options.mezzo, operative.tipologia_mezzo)} testid="op-mezzo" />
      <Sel label="Causale" value={operative.causale} onChange={upd("causale")} options={withCurrent(options.causale, operative.causale)} testid="op-causale" />
      <Field label="Necessità / Condizioni" value={operative.necessita} onChange={upd("necessita")} testid="op-necessita" />
      <Sel label="Mobilizzazione" value={operative.mobilizzazione} onChange={upd("mobilizzazione")} options={withCurrent(options.mobilizzazione, operative.mobilizzazione)} testid="op-mobilizzazione" />
      <Sel label="Tratta" value={operative.tratta} onChange={upd("tratta")} options={TRATTA_OPTIONS} testid="op-tratta" />
      <div className="grid grid-cols-2 gap-3 items-end">
        <div>
          <Label className="nx-label">Richiesta FM</Label>
          <div className="flex items-center gap-2 h-10 mt-1.5">
            <Switch data-testid="op-richiesta-fm" checked={!!operative.richiesta_fm}
              onCheckedChange={(v) => setOperative({ ...operative, richiesta_fm: v, minuti_fm: v ? operative.minuti_fm : "" })} />
            <span className={`text-sm font-medium ${operative.richiesta_fm ? "text-primary" : "text-slate-500"}`}>{operative.richiesta_fm ? "Sì" : "No"}</span>
          </div>
        </div>
        <Field label="Minuti FM inclusi" type="number" value={operative.minuti_fm} disabled={!operative.richiesta_fm} onChange={upd("minuti_fm")} testid="op-minuti-fm" placeholder="es. 30" />
      </div>
    </SEZ>
  );
};
